/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useSafeAreaInsets,
  SafeAreaView,
} from 'react-native-safe-area-context';
import Toast from 'react-native-toast-message';
import {
  TouchableOpacity,
  Dimensions,
  View,
  ActivityIndicator,
  KeyboardAvoidingView,
  StyleSheet,
  RefreshControl,
  Keyboard,
  BackHandler,
  ScrollView,
} from 'react-native';
import {
  formGroup,
  formWrapper,
  formGroupSpace,
} from '@assets/styles/formStyles';
import {
  isWeb,
  isMobileWeb,
  isAndroid,
  isIos,
  isNative,
  isWebPlatform,
} from '@global/screens';
import Colors from '@global/colors';
import { showPopup } from '@/store/modal';
import { LinearGradient } from 'expo-linear-gradient';
import { isVn } from '@global/helpers';
import SociollaText from '@components/sociolla/SociollaText';
import ModalFull from '@components/modal/ModalFull';
import Button from '@components/form/Button';
import Image from '@components/global/Image';
import { Portal } from '@gorhom/portal';
import SyncStorage from '@global/storage';
import SwitcherDropdown from '@components/shared/SwitcherDropdown';
import RadioIcon from '@components/shared/RadioIcon';
import {
  changeLanguage,
  SUPPORTED_LANGUAGES,
  VISIBLE_LANGUAGES,
} from '@/store/language';

import { paginationAdded, paramsReseted, selectParams } from '@/store/params';
import { useNavigation } from '@react-navigation/native';
import useAndroidKeyboardHeight from '@/hooks/useAndroidKeyboardHeight';

const dimension = Dimensions.get('screen');

const ContainerWrapper = React.memo(
  ({ testID = 'container', style = {}, children }) => {
    return isWeb ? (
      <View
        testID={testID}
        nativeID="container-web"
        style={[container.container, style]}>
        {children}
      </View>
    ) : (
      <View testID={testID} style={[container.containerMobile, style]}>
        {children}
      </View>
    );
  },
  (prev, next) => prev == next,
);

// main container
const Container = React.memo(
  (props) => {
    return <ContainerWrapper {...props} />;
  },
  (prev, next) => prev == next,
);

const container = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    maxHeight: isWeb ? '100%' : dimension.height - 55,
    minHeight: isWeb ? '100%' : dimension.height - 55,
    padding: 30,
    backgroundColor: Colors.grey5,
    flex: 1,
    ...(isWeb
      ? {
          overflow: 'auto',
        }
      : {}),
  },
  containerMobile: {
    flex: 1,
    backgroundColor: Colors.white,
  },
});

// child for main container
const Wrapper = React.memo(
  ({
    children,
    white = true,
    rounded,
    style = {},
    bottomSpace = 0,
    hasProgressBar = false,
    fullWidth = false,
    isHeight = false,
    minHeight = 0,
    isUndefined = false,
  }) => {
    const insets = useSafeAreaInsets();
    const keyboardHeight = useAndroidKeyboardHeight();
    const heightContainer = isWeb
      ? '100%'
      : dimension.height -
        insets.top -
        insets.bottom -
        55 -
        bottomSpace -
        (hasProgressBar ? 15 : 0);

    return (
      <KeyboardAvoidingView
        behavior={
          isAndroid
            ? undefined
            : isUndefined
            ? undefined
            : isHeight
            ? 'height'
            : isNative
            ? 'padding'
            : 'position'
        }
        style={{
          width: isWeb && !fullWidth ? '80%' : '100%',
          maxWidth: fullWidth ? '100%' : 840,
          backgroundColor: white ? Colors.white : 'transparent',
          ...(rounded
            ? {
                borderRadius: isWeb ? 7 : 0,
              }
            : {}),
          ...(!isWeb
            ? {
                minHeight: minHeight ? minHeight : heightContainer,
              }
            : {}),
          ...(isAndroid ? { marginBottom: keyboardHeight } : {}),
          ...style,
        }}
        keyboardVerticalOffset={30}>
        {children}
      </KeyboardAvoidingView>
    );
  },
  (prev, next) => prev == next,
);

const Card = React.memo(
  ({
    testID = 'card-default',
    children,
    type = 'default',
    style = {},
    touchable = false,
    onPress,
  }) => {
    let background = Colors.white;
    let border = Colors.blue0;
    if (type == 'primary') {
      background = `${Colors.blue0}10`;
      border = Colors.blue0;
    } else if (type == 'danger') {
      background = `${Colors.red1}10`;
      border = Colors.red1;
    } else if (type == 'warning') {
      background = `${Colors.yellow0}10`;
      border = Colors.yellow0;
    } else if (type == 'success') {
      background = `${Colors.green1}10`;
      border = Colors.green1;
    }

    const onClick = () => {
      try {
        if (touchable) {
          onPress();
        }
      } catch (error) {}
    };

    return (
      <TouchableOpacity
        testID={testID}
        activeOpacity={1}
        onPress={() => onClick()}
        style={{
          width: '100%',
          backgroundColor: background,
          borderTopWidth: 5,
          borderTopColor: border,
          borderRadius: 8,
          overflow: 'hidden',
          padding: 15,
          ...style,
        }}>
        {children}
      </TouchableOpacity>
    );
  },
  (prev, next) => prev == next,
);

// title section for every pages
const Title = React.memo(
  ({ testID = 'title-default', title, children, style = {} }) => {
    return (
      <View
        testID={testID}
        style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 25,
          ...style,
        }}>
        <SociollaText type="medium" style={{ fontSize: 20 }}>
          {title}
        </SociollaText>
        {children}
      </View>
    );
  },
  (prev, next) => prev == next,
);

// back button for every pages
const Back = React.memo(
  ({ testID = 'back-btn', single = false, title, onCallback }) => {
    const BackComponent = useMemo(() => {
      return single ? (
        <SociollaText
          testID={`${testID}-back-btn`}
          type="medium"
          style={{ fontSize: 20 }}>
          {title}
        </SociollaText>
      ) : (
        <>
          <Image
            testID={`${testID}-back-img`}
            style={{ width: 7, height: 12, marginRight: 15 }}
            width={7}
            height={12}
            svg={true}
            source={require('@assets/img/icons/arrow-left-grey.svg')}
          />
          <SociollaText
            testID={`${testID}-back-btn`}
            style={{
              fontSize: 14,
              lineHeight: 16,
            }}>
            Back to {title}
          </SociollaText>
        </>
      );
    }, [single, title]);
    return (
      <TouchableOpacity
        testID={testID}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          alignSelf: 'flex-start',
          marginBottom: 25,
          ...(isWeb ? { cursor: 'pointer' } : {}),
        }}
        activeOpacity={0.6}
        onPress={onCallback}>
        {BackComponent}
      </TouchableOpacity>
    );
  },
  (prev, next) => prev == next,
);

// back button for every pages
const BackCustom = React.memo(
  ({ single = false, title, onCallback }) => {
    const BackComponent = useMemo(() => {
      return isNative || Dimensions.get('window').width < 991 ? (
        <View style={{ flexDirection: 'row' }}>
          <TouchableOpacity
            style={{ paddingHorizontal: 15, paddingTop: 25 }}
            onPress={onCallback}>
            <Image
              width={20}
              height={20}
              style={{ width: 20, height: 20 }}
              svg={true}
              source={require('@assets/img/icons/arrow-left-white.svg')}
            />
          </TouchableOpacity>
        </View>
      ) : (
        false
      );
    }, [single, title]);
    return (
      <TouchableOpacity
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          alignSelf: 'flex-start',
          marginBottom: 25,
          ...(isWeb ? { cursor: 'pointer' } : {}),
        }}
        activeOpacity={0.6}
        onPress={onCallback}>
        {BackComponent}
      </TouchableOpacity>
    );
  },
  (prev, next) => prev == next,
);

// global loader component
const Loader = React.memo(
  ({ type = 'large' }) => {
    return (
      <View
        style={{
          width: '100%',
          paddingVertical: type == 'tiny' ? 0 : 25,
        }}>
        <ActivityIndicator
          size={type == 'tiny' ? 13 : type}
          color={Colors.blue0}
        />
      </View>
    );
  },
  (prev, next) => prev == next,
);

// form wrapper for every forms
const FormWrapper = React.memo(
  ({ style = {}, children }) => {
    return <View style={{ ...formWrapper, ...style }}>{children}</View>;
  },
  (prev, next) => prev == next,
);

// form group for every input types
const FormGroup = React.memo(
  ({ style = {}, children }) => {
    return (
      <View style={{ ...formGroup, ...formGroupSpace, ...style }}>
        {children}
      </View>
    );
  },
  (prev, next) => prev == next,
);

// component for filter popup
const Filter = React.memo(
  ({
    testID = 'filter-modal',
    name = '',
    style = {},
    isLocalVariable = false,
    hasFilterData = false,
    children,
    withoutScroll = false,
    onReset,
    onApply,
    filterName = null,
  }) => {
    const dispatch = useDispatch();
    const paramsState = useSelector(selectParams(filterName)); // existing parameters for filter
    const isShowFilter = useSelector((state) => state.modal.showFilter);
    const insets = useSafeAreaInsets();
    const buttonWidth = isWeb
      ? 140
      : dimension.width / 2 - (isMobileWeb ? 20 : 25);

    const onApplyFilter = () => {
      if (paramsState.skip > 0) {
        dispatch(
          paginationAdded({
            key: filterName,
            skip: 0,
            limit: paramsState.limit,
          }),
        );
      }
      let hasFilter = false;
      const filters = paramsState.filter;
      const params = Object.keys(filters);
      for (let i = 0; i < params.length; i++) {
        const key = params[i];
        if (filters[key] || filters[key] === false) {
          hasFilter = true;
        }
      }
      if (isLocalVariable && hasFilterData) {
        hasFilter = true;
      }
      if (hasFilter) {
        onApply();
      } else {
        Toast.show({ text1: 'Please fill something.', type: 'error' });
      }
    };

    const onResetFilter = () => {
      dispatch(paramsReseted({ key: filterName }));
      onReset();
      dispatch(showPopup({ name: 'showFilter', value: false }));
    };

    const FilterWrapper = useMemo(() => {
      return withoutScroll ? (
        <View>{children}</View>
      ) : (
        <ScrollView
          contentContainerStyle={
            isNative || isMobileWeb ? { paddingBottom: 90 } : undefined
          }>
          {children}
        </ScrollView>
      );
    }, [withoutScroll, children]);

    return (
      <ModalFull
        testID={testID}
        title="Filter"
        show={name == isShowFilter}
        noTranslate={true}
        onClose={() =>
          dispatch(showPopup({ name: 'showFilter', value: false }))
        }>
        <View
          testID={`${testID}-wrapper`}
          style={{
            position: 'relative',
            width: '100%',
            paddingHorizontal: isWeb ? 20 : 15,
            maxHeight: isWeb
              ? 'calc(100vh - 150px)'
              : isMobileWeb
              ? 'calc(100dvh - 150px)'
              : dimension.height - (isAndroid ? 130 : 110),
            minHeight: isNative
              ? dimension.height - (isAndroid ? 130 : 110)
              : 'auto',
            ...style,
          }}>
          {FilterWrapper}
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: isWeb ? 'center' : 'space-between',
              paddingTop: isWeb ? 20 : 15,
              paddingBottom:
                (isWeb ? 20 : 15) + (isMobileWeb ? insets.bottom : 0),
              paddingHorizontal: isWeb ? 20 : 10,
              backgroundColor: Colors.white,
              position: isNative
                ? 'absolute'
                : isMobileWeb
                ? 'fixed'
                : 'relative',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 1000,
              ...style,
            }}>
            <Button
              testID={`${testID}-reset-btn`}
              type="default"
              rounded={true}
              buttonStyle={{
                width: buttonWidth,
                ...(isWeb
                  ? { marginHorizontal: 10 }
                  : !isMobileWeb
                  ? { marginHorizontal: 5 }
                  : {}),
              }}
              title={
                <SociollaText
                  type="bold"
                  style={{ letterSpacing: 0.5, color: Colors.black }}>
                  Reset
                </SociollaText>
              }
              onPress={onResetFilter}
            />
            <Button
              testID={`${testID}-apply-btn`}
              rounded={true}
              buttonStyle={{
                width: buttonWidth,
                ...(isWeb
                  ? { marginHorizontal: 10 }
                  : !isMobileWeb
                  ? { marginHorizontal: 5 }
                  : {}),
              }}
              title={
                <SociollaText
                  type="bold"
                  style={{ letterSpacing: 0.5, color: Colors.white }}>
                  Apply
                </SociollaText>
              }
              onPress={onApplyFilter}
            />
          </View>
        </View>
      </ModalFull>
    );
  },
  (prev, next) => prev == next,
);

// component for filter item on filter popup
const FilterItem = React.memo(
  ({ style = {}, lastItem = false, children }) => {
    return (
      <View
        style={{
          paddingVertical: 15,
          borderBottomWidth: 1,
          borderBottomColor: lastItem ? 'transparent' : Colors.grey0,
          ...style,
        }}>
        {children}
      </View>
    );
  },
  (prev, next) => prev == next,
);

// global item mobile component
const ItemMobile = React.memo(
  ({
    testID = 'item-mobile',
    style = {},
    children,
    left = false,
    column = false,
    touchable = false,
    onPress = null,
  }) => {
    const ItemWrapper = useMemo(() => {
      const itemStyle = {
        width: '100%',
        paddingHorizontal: 15,
        paddingVertical: 20,
        backgroundColor: Colors.white,
        borderBottomWidth: 1,
        borderBottomColor: Colors.grey0,
        flexDirection: column ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: left ? 'flex-start' : 'space-between',
        ...style,
      };

      return touchable ? (
        <TouchableOpacity
          testID={testID}
          activeOpacity={0.6}
          style={itemStyle}
          onPress={onPress}>
          {children}
        </TouchableOpacity>
      ) : (
        <View testID={testID} style={itemStyle}>
          {children}
        </View>
      );
    }, [touchable, children]);

    return ItemWrapper;
  },
  (prev, next) => prev == next,
);

// .........Logo bg layout for login, forget password, reset password page
const logo = {
  width: isWeb ? 240 : 250,
  height: isWeb ? 90 : 95,
};

// background wrapper for login and reset password
const BgWrapper = React.memo(
  ({ testID = 'wrapper-default', children, minimumScaling }) => {
    const dispatch = useDispatch();
    const navigation = useNavigation();
    const language = useSelector((state) => state.language.selected);
    const [isShowCountryDropdown, setIsShowCountryDropdown] = useState(false);
    const [isShowLanguageDropdown, setIsShowLanguageDropdown] = useState(false);
    const isVietnam = isVn();
    const companyName = isVietnam
      ? 'Social Bella Vietnam Company Limited'
      : 'PT Semesta Distribusi Indonesia';
    const screenHeight = Dimensions.get('window').height;

    const openCountryList = () => {
      setIsShowLanguageDropdown(false);
      setIsShowCountryDropdown(!isShowCountryDropdown);
    };

    const openLanguageList = () => {
      setIsShowCountryDropdown(false);
      setIsShowLanguageDropdown(!isShowLanguageDropdown);
    };

    const toggleCountry = (coun) => {
      setIsShowCountryDropdown(false);
      const curCoun = isVietnam ? 'VN' : 'ID';
      if (curCoun == coun) {
        return;
      }

      SyncStorage.set('soc_cn', coun);

      navigation.replace('LoginScreen');
    };

    const switchLanguage = (code) => {
      dispatch(changeLanguage(code));
      setIsShowLanguageDropdown(false);
    };

    const countryOptions = [
      {
        key: 'ID',
        label: 'Indonesia',
        testID: `${testID}-country-option-id`,
        onSelect: () => toggleCountry('ID'),
        icon: (
          <Image
            style={styles.flagIcon}
            width={16}
            height={16}
            svg={true}
            source={require('@assets/img/icons/ID.svg')}
          />
        ),
      },
      {
        key: 'VN',
        label: 'Vietnam',
        testID: `${testID}-country-option-vn`,
        onSelect: () => toggleCountry('VN'),
        icon: (
          <Image
            style={styles.flagIcon}
            width={16}
            height={16}
            svg={true}
            source={require('@assets/img/icons/VN.svg')}
          />
        ),
      },
    ];

    const languageOptions = VISIBLE_LANGUAGES.map((lang) => ({
      key: lang.code,
      label: lang.label,
      testID: `${testID}-language-option-${lang.code}`,
      disabled: !lang.enabled,
      onSelect: () => switchLanguage(lang.code),
      icon: <RadioIcon selected={lang.code === language} />,
    }));

    const currentLanguage =
      SUPPORTED_LANGUAGES.find((lang) => lang.code === language) ||
      SUPPORTED_LANGUAGES[0];

    const languageSwitcher = (
      <SwitcherDropdown
        testIDPrefix={`${testID}-change-language`}
        buttonStyle={styles.countryHeader}
        buttonContent={
          <>
            <Image
              testID={`${testID}-language-globe`}
              style={styles.flagIcon}
              width={16}
              height={16}
              svg={true}
              source={require('@assets/img/icons/globe-grey.svg')}
            />
            <SociollaText
              testID={`${testID}-language`}
              type="regular"
              style={styles.countryCodeText}>
              {currentLanguage.label}
            </SociollaText>
          </>
        }
        arrowIcon={
          <Image
            testID={`${testID}-language-options`}
            source={require('@assets/img/icons/arrow-down-grey.svg')}
            style={{ width: 10, height: 5, marginLeft: 5 }}
            width={10}
            height={5}
            svg={true}
          />
        }
        isOpen={isShowLanguageDropdown}
        onToggle={openLanguageList}
        options={languageOptions}
        dropdownStyle={styles.loginDropdown}
        optionStyle={styles.loginDropdownItem}
        optionTextStyle={styles.loginDropdownText}
        disabledOptionTextStyle={[styles.loginDropdownText, { opacity: 0.4 }]}
      />
    );

    // On web the country control was never interactive (no dropdown/click
    // behavior) prior to the Language switcher being added alongside it —
    // keep that original static display for web; native keeps the
    // SwitcherDropdown behavior.
    const countryDisplay = (
      <>
        <Image
          testID={`${testID}-flag-icon`}
          style={styles.flagIcon}
          width={16}
          height={16}
          svg={true}
          source={
            isVietnam
              ? require('@assets/img/icons/VN.svg')
              : require('@assets/img/icons/ID.svg')
          }
        />
        <SociollaText
          testID={`${testID}-country`}
          type="regular"
          style={styles.countryCodeText}>
          {isVietnam ? 'VN' : 'ID'}
        </SociollaText>
      </>
    );

    const countrySwitcher = isWeb ? (
      <View
        testID={`${testID}-change-country-button`}
        style={styles.countryHeader}>
        {countryDisplay}
      </View>
    ) : (
      <SwitcherDropdown
        testIDPrefix={`${testID}-change-country`}
        buttonStyle={styles.countryHeader}
        buttonContent={countryDisplay}
        arrowIcon={
          <Image
            testID={`${testID}-country-options`}
            source={require('@assets/img/icons/arrow-down-grey.svg')}
            style={{ width: 10, height: 5, marginLeft: 5 }}
            width={10}
            height={5}
            svg={true}
          />
        }
        isOpen={isShowCountryDropdown}
        onToggle={openCountryList}
        options={countryOptions}
        dropdownStyle={styles.loginDropdownLeft}
        optionStyle={styles.loginDropdownItem}
        optionTextStyle={styles.loginDropdownText}
      />
    );

    return (
      <SafeAreaView
        testID={testID}
        style={styles.mainWrapper}
        edges={['top', 'left', 'right']}>
        <LinearGradient
          colors={['#A8D6F2', '#A8D6F2', '#7292C9', '#38489D']}
          locations={[0.3388, 0.485, 0.81, 1]}
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          style={styles.wrapper}>
          <KeyboardAvoidingView
            behavior="position"
            keyboardVerticalOffset={
              minimumScaling ? -(screenHeight * 0.5) : 100
            }>
            {isWeb ? (
              <View style={styles.loginHeader}>
                <SociollaText
                  testID={`${testID}-company-title`}
                  type="regular"
                  style={styles.companyText}>
                  {companyName}
                </SociollaText>
                <View style={styles.switcherGroup}>
                  {languageSwitcher}
                  {countrySwitcher}
                </View>
              </View>
            ) : (
              <>
                <View style={styles.loginHeader}>
                  {countrySwitcher}
                  {languageSwitcher}
                </View>
                <SociollaText
                  testID={`${testID}-company-title`}
                  type="regular"
                  style={styles.companyTextCentered}>
                  {companyName}
                </SociollaText>
              </>
            )}
            <View style={styles.logoWrapper}>
              <Image
                testID={`${testID}-logo`}
                key="logoApps"
                width={logo.width}
                height={logo.height}
                style={styles.logoApps}
                resizeMode="contain"
                source={require('@assets/img/logo/nina_2025.svg')}
                svg
              />
            </View>
            {children}
          </KeyboardAvoidingView>
        </LinearGradient>
      </SafeAreaView>
    );
  },
  (prev, next) => prev == next,
);

// Scrollview with refresher
const ScrollViewRefresher = React.memo(
  ({
    innerRef = () => {},
    children = null,
    scrollEventThrottle = 16,
    style = {},
    contentContainerStyle = {},
    isTable = false,
    showSearch = true,
    isFullHeight = false,
    maxHeight = 0,
    hasHeader = false,
    hasFooter = false,
    noScroll = false,
    onScroll = () => {},
    onCallback = () => {},
  }) => {
    if (noScroll) {
      return <>{children}</>;
    }
    const insets = useSafeAreaInsets();
    const minHeight = isWeb
      ? '100%'
      : dimension.height - insets.top - insets.bottom - 55;
    const paddingBottom = isTable
      ? (isAndroid ? 150 : isIos ? 55 : 0) +
        (hasFooter ? (isWebPlatform ? 140 : isAndroid ? 70 : 55) : 0) -
        (!showSearch ? 66 : 0) -
        (hasHeader ? 47 : 0)
      : isAndroid
      ? 100
      : 0;
    const finalHeight = maxHeight ? 'auto' : minHeight;

    const [refreshing, setRefreshing] = useState(false);

    const onRefresh = useCallback(() => {
      setRefreshing(true);
      onCallback();
      setTimeout(() => {
        setRefreshing(false);
      }, 1000);
    }, []);

    const PaddingBottom = useMemo(() => {
      return paddingBottom && isFullHeight ? (
        <View style={{ height: paddingBottom }}></View>
      ) : (
        false
      );
    }, [paddingBottom, isFullHeight]);

    return (
      <KeyboardWrapper
        innerRef={(val) => innerRef(val)}
        scrollEventThrottle={scrollEventThrottle}
        contentContainerStyle={[
          contentContainerStyle,
          { width: isWeb ? '100%' : dimension.width },
        ]}
        style={[
          style,
          isFullHeight ? { height: finalHeight } : {},
          maxHeight ? { maxHeight: maxHeight } : {},
        ]}
        showsVerticalScrollIndicator={isWeb}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
        onScroll={(e) => {
          try {
            onScroll(e);
          } catch (error) {}
        }}>
        {children}
        {PaddingBottom}
      </KeyboardWrapper>
    );
  },
  (prev, next) => prev == next,
);

const KeyboardWrapper = React.memo(
  ({
    innerRef = () => {},
    children = null,
    style = {},
    contentContainerStyle = {},
    scrollEventThrottle = 0,
    refreshControl = undefined,
    behavior = isIos ? 'padding' : 'height',
    keyboardVerticalOffset = 65,
    onScroll = () => {},
    scrollEnabled = true,
  }) => {
    const scrollRef = useRef();
    useEffect(() => {
      let mounted = true;
      if (mounted) {
        innerRef(scrollRef);
      }
      return () => {
        mounted = false;
      };
    }, [scrollRef]);

    return (
      <KeyboardAvoidingView
        style={style}
        behavior={behavior}
        keyboardVerticalOffset={keyboardVerticalOffset}>
        <ScrollView
          ref={scrollRef}
          style={style}
          scrollEventThrottle={scrollEventThrottle}
          contentContainerStyle={contentContainerStyle}
          showsVerticalScrollIndicator={isWeb}
          refreshControl={refreshControl}
          onScroll={onScroll}
          scrollEnabled={scrollEnabled}>
          {children}
        </ScrollView>
      </KeyboardAvoidingView>
    );
  },
  (prev, next) => prev == next,
);

const Spacer = React.memo(
  ({ space = 50 }) => {
    return <View style={{ width: '100%', height: space }}></View>;
  },
  (prev, next) => prev == next,
);

const ButtonStickyItem = React.memo(
  ({ item, index }) => {
    return item.component ? (
      <View
        style={{ marginBottom: 15 }}
        key={`button-sticky-component-${index}`}>
        {item.component}
      </View>
    ) : (
      <Button
        key={`button-sticky-${index}`}
        rounded
        type={item.type ? item.type : null}
        title={
          <SociollaText
            type="bold"
            style={{
              fontSize: 16,
              letterSpacing: 0.5,
              color: item.type == 'default' ? Colors.black : Colors.white,
            }}>
            {item.title}
          </SociollaText>
        }
        buttonStyle={{ marginBottom: 15 }}
        disabledStyle={{ marginBottom: 15 }}
        disabled={item.disabled ? true : false}
        onPress={(evt) => (item.onPress ? item.onPress(evt) : null)}
      />
    );
  },
  (prev, next) => prev == next,
);

const ButtonSticky = React.memo(
  ({
    testID = 'button-sticky',
    show = false,
    route = null,
    customHost = 'button-sticky',
    buttons = [],
  }) => {
    const navigation = useNavigation();
    const insets = useSafeAreaInsets();
    const [showButton, setShowButton] = useState(true);
    const [showKeyboard, setShowKeyboard] = useState(false);

    const didShow = () => {
      setShowButton(false);
    };

    const didShowKeyboard = () => {
      setShowKeyboard(true);
    };

    const didHideKeyboard = () => {
      setShowKeyboard(false);
    };

    useEffect(() => {
      let mounted = true;
      if (mounted) {
        if (show && navigation.isFocused()) {
          setShowButton(true);
        } else {
          setShowButton(false);
        }
      }

      const keyboardDidShowListener = Keyboard.addListener(
        'keyboardDidShow',
        didShowKeyboard,
      );
      const keyboardDidHideListener = Keyboard.addListener(
        'keyboardDidHide',
        didHideKeyboard,
      );
      let backHandlerListener;
      if (!isWebPlatform) {
        backHandlerListener = BackHandler.addEventListener(
          'hardwareBackPress',
          didShow,
        );
      }

      navigation.addListener('beforeRemove', () => {
        setShowButton(false);
      });

      navigation.addListener('blur', () => {
        setShowButton(false);
      });

      return () => {
        mounted = false;
        keyboardDidShowListener.remove();
        keyboardDidHideListener.remove();
        if (backHandlerListener) {
          backHandlerListener.remove();
        }
        navigation.removeListener('beforeRemove');
        navigation.removeListener('blur');
      };
    }, [route]);

    const ButtonList = useMemo(() => {
      return buttons
        .filter((btn) => btn.title || btn.component)
        .map((item, idx) => (
          <ButtonStickyItem item={item} index={idx} key={idx} />
        ));
    }, [buttons]);

    return show && showButton && !showKeyboard && buttons?.length ? (
      <Portal name="portal-button-sticky" hostName={customHost}>
        <View
          testID={testID}
          style={{
            width: '100%',
            paddingTop: 15,
            // At targetSdk 36 the Android nav bar draws over the app with no
            // opt-out, so the bar must clear it itself.
            paddingBottom: isMobileWeb
              ? 10 + insets.bottom + 12
              : 10 + (isAndroid ? insets.bottom : 0),
            paddingHorizontal: 15,
            position: isNative
              ? 'absolute'
              : isMobileWeb
              ? 'fixed'
              : 'relative',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 3,
            elevation: 4,
            backgroundColor: Colors.white,
            borderTopColor: Colors.grey3,
            borderTopWidth: 1,
          }}>
          {ButtonList}
        </View>
      </Portal>
    ) : (
      false
    );
  },
  (prev, next) => prev == next,
);

const styles = StyleSheet.create({
  mainWrapper: {
    width: '100%',
    flex: 1,
    backgroundColor: '#A8D6F2',
  },
  wrapper: {
    minHeight: Dimensions.get('window').height,
    flexGrow: 1,
    backgroundColor: '#FFFFFF',
    position: 'relative',
    alignItems: 'stretch',
    ...(isMobileWeb
      ? {
          overflow: 'hidden',
        }
      : {}),
  },
  loginHeader: {
    width: '100%',
    paddingHorizontal: isWeb ? 30 : 16,
    paddingTop: isWeb ? 12 : 8,
    marginTop: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    zIndex: 20,
    elevation: 20,
  },
  companyText: {
    fontSize: isWeb ? 14 : 12,
    color: Colors.black,
    fontFamily: 'figtree-regular',
  },
  companyTextCentered: {
    width: '100%',
    textAlign: 'center',
    marginTop: 70,
    paddingHorizontal: 16,
    fontSize: 12,
    color: Colors.black,
    fontFamily: 'figtree-regular',
  },
  switcherGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  countryHeader: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Colors.white,
    borderRadius: 20,
    paddingVertical: 6,
    paddingHorizontal: 12,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.08,
    shadowRadius: 2,
    elevation: 2,
  },
  flagIcon: {
    width: 18,
    height: 18,
    marginRight: 6,
  },
  countryCodeText: {
    fontSize: 12,
    color: Colors.black,
    fontFamily: 'figtree-regular',
  },
  loginDropdown: {
    position: 'absolute',
    right: 0,
    top: 36,
    width: 180,
    backgroundColor: Colors.white,
    borderRadius: 4,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
    zIndex: 10,
  },
  loginDropdownLeft: {
    position: 'absolute',
    left: 0,
    top: 36,
    width: 180,
    backgroundColor: Colors.white,
    borderRadius: 4,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
    zIndex: 10,
  },
  loginDropdownItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
  loginDropdownText: {
    fontSize: 12,
    fontFamily: 'figtree-regular',
    color: Colors.black,
  },
  logoWrapper: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: isWeb ? 40 : -20,
    marginBottom: isWeb ? 32 : 24,
  },
  logoApps: {
    width: logo.width,
    height: logo.height,
    marginVertical: 16,
  },
});

export {
  Container,
  Wrapper,
  Card,
  Title,
  Back,
  Loader,
  FormWrapper,
  FormGroup,
  Filter,
  FilterItem,
  ItemMobile,
  BgWrapper,
  ScrollViewRefresher,
  KeyboardWrapper,
  Spacer,
  ButtonSticky,
  BackCustom,
};
